import { FC } from 'react';

import SymbolTable from '../../../../../components/SymbolTable/SymbolTable';
import { SymbolTableGrid } from '../../../../../components/SymbolTable/SymbolTableGrid.enum';
import { EPIC_MOVERS_INTERNAL_ROW_ITEMS_COUNT } from '../../../EpicMovers.constants';
import { EpicMoversInternalRowModel, EpicMoversInternalTabProps } from '../../EpicMoversInternal.types';
import EpicMoversInternalRow from '../EpicMoversInternalRow/EpicMoversInternalRow';

/**
 * Gainers and losers rendered the same table through two identical components.
 * They only differed by the GTM `subsection` string, which now travels with
 * `onSymbolClick`, so one component covers both tabs.
 */
const EpicMoversInternalTab: FC<EpicMoversInternalTabProps> = ({
  rows,
  isLoading,
  enableRowToggle,
  renderHeaders,
  onSymbolClick,
}) => (
  <SymbolTable
    items={rows}
    isLoading={isLoading}
    renderHeaders={renderHeaders}
    rowItemsCount={EPIC_MOVERS_INTERNAL_ROW_ITEMS_COUNT}
    skeletonGrid={SymbolTableGrid.FOUR_ROW_ITEMS_GRID}
    renderRow={(row: EpicMoversInternalRowModel) => (
      <EpicMoversInternalRow
        key={row.symbol}
        row={row}
        enableToggle={enableRowToggle}
        onSymbolClick={onSymbolClick}
      />
    )}
  />
);

export default EpicMoversInternalTab;
